import pt from "../../locales/pt.json";

export const depoNome1 = pt.depoimentos.nomes.depoNome1;
export const depoNome2 = pt.depoimentos.nomes.depoNome2;
export const depoNome3 = pt.depoimentos.nomes.depoNome3;
export const depoNome4 = pt.depoimentos.nomes.depoNome4;
